export default "/images/plaatje.png?37b78d71748162aedaa01b9914174b47";